
const BrowserStorageQuotaService = require("./BrowserStorageQuotaService");
const MemoryUsageService = require("./MemoryUsageService");

const ConfigurationFactory = require("../ConfigurationFactory");

const MINUTES = 60 * 1000;
const LOG_INTERVAL = 3 * MINUTES;

const service = {};

service.start = () => {
  // Just webplayer based for now
  if( !ConfigurationFactory.isWebPlayer() ) {
    return;
  }

  setInterval(() => {
    MemoryUsageService.logMemoryUsage();
    BrowserStorageQuotaService.logEstimateQuota();
  }, LOG_INTERVAL);
}

module.exports = service;
